import PropTypes from 'prop-types';
import React from 'react';
import homeDetailsSVGs from './FeatureTagSVGData';
import { FeaturesStyles } from './Features.styled';

const Features = ({ featuresArray }) => {
  return (
    <FeaturesStyles>
      <h4 className="features-heading">Features</h4>

      <ul>
        {homeDetailsSVGs.map((featureIconPair, i) => {
          if (featuresArray.includes(featureIconPair.tagName)) {
            return (
              <li key={i}>
                {React.createElement(featureIconPair.icon, {
                  className: 'feature-icon',
                  width: '48',
                  height: '48',
                })}
                <p className="feature-tag-text">{featureIconPair.tagName}</p>
              </li>
            );
          }
        })}
      </ul>
    </FeaturesStyles>
  );
};

Features.propTypes = {
  featuresArray: PropTypes.array,
};

export default Features;
